var map = {
	"./action_img.png": 198,
	"./background.png": 199,
	"./banner_shap.png": 200,
	"./bulb.png": 201,
	"./cloud-computing.png": 202,
	"./cloud.png": 203,
	"./cloud_01.png": 204,
	"./cloud_02.png": 205,
	"./cloud_03.png": 206,
	"./cloud_04.png": 207,
	"./cloud_05.png": 208,
	"./cloud_06.png": 209,
	"./cloud_blue.png": 210,
	"./crm_img1.jpg": 211,
	"./crm_img2.jpg": 212,
	"./crm_img3.jpg": 213,
	"./erp_dashboard.jpg": 214,
	"./erp_icon1.png": 215,
	"./erp_icon2.png": 216,
	"./erp_icon3.png": 217,
	"./erp_icon4.png": 218,
	"./erp_icon5.png": 219,
	"./erp_icon6.png": 220,
	"./growth.png": 221,
	"./img/01.png": 222,
	"./img/02.png": 223,
	"./img/03.png": 224,
	"./img/04.png": 225,
	"./img/05.png": 226,
	"./img/06.png": 227,
	"./img/07.png": 228,
	"./img/08.png": 229,
	"./img/09.png": 230,
	"./img/10.png": 231,
	"./img/11.png": 232,
	"./img/12.png": 233,
	"./img/13.png": 234,
	"./img/14.png": 235,
	"./img/15.png": 236,
	"./img/16.png": 237,
	"./img/17.png": 238,
	"./img/18.png": 239,
	"./img/19.png": 240,
	"./img/20.png": 241,
	"./quote.png": 242,
	"./rocket.png": 243,
	"./settings.png": 244,
	"./settings1.png": 245,
	"./shape.png": 246,
	"./software_development.png": 247,
	"./team.png": 248,
	"./testimonial_img.jpg": 249,
	"./testimonial_img2.jpg": 250,
	"./website.png": 251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 197;